import type { ReactElement, SVGProps } from 'react';

import { arrowTopRight as IconArrowTopRight } from '@/components/icons/arrowTopRight';
import { check as IconCheck } from '@/components/icons/check';
import { chevronRight as IconChevronRight } from '@/components/icons/chevronRight';
import { copy as IconCopy } from '@/components/icons/copy';
import { discord as IconDiscord } from '@/components/icons/discord';
import { externalLink as IconExternalLink } from '@/components/icons/externalLink';
import { info as IconInfo } from '@/components/icons/info';
import { plus as IconPlus } from '@/components/icons/plus';
import { telegramColorless as IconTelegramColorless } from '@/components/icons/telegramColorless';
import { twitter as IconTwitter } from '@/components/icons/twitter';
import type { NotificationIconKey } from '@/types/notification.types';

type IconElement = ReactElement<SVGProps<SVGSVGElement>>;

// Map from serializable icon keys to React elements
// Icons are rendered at 16x16 by default for notification context
export const NOTIFICATION_ICON_MAP: Record<NotificationIconKey, IconElement> = {
  externalLink: <IconExternalLink width="16" height="16" />,
  copy: <IconCopy width="16" height="16" />,
  check: <IconCheck width="16" height="16" />,
  plus: <IconPlus width="16" height="16" />,
  info: <IconInfo width="16" height="16" />,
  telegram: <IconTelegramColorless />,
  discord: <IconDiscord width="16" height="16" />,
  twitter: <IconTwitter width="16" height="16" />,
  arrowTopRight: <IconArrowTopRight width="16" height="16" />,
  chevronRight: <IconChevronRight width="16" height="16" />,
};

/**
 * Resolve a serializable icon key to its React element
 */
export const resolveIcon = (key?: NotificationIconKey): IconElement | undefined => {
  return key ? NOTIFICATION_ICON_MAP[key] : undefined;
};
